/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import {
	GlobalAppShortcuts as GlobalAppShortcutsWithoutErrorBoundary,
	type GlobalAppShortcutsProps,
} from './ui/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export const GlobalAppShortcuts = ({ menuId }: GlobalAppShortcutsProps): React.JSX.Element => (
	<JSErrorBoundary
		fallback="flag"
		id="global-app-shortcuts-section"
		packageName={PACKAGE_NAME}
		teamName={TEAM_NAME}
	>
		<GlobalAppShortcutsWithoutErrorBoundary menuId={menuId} />
	</JSErrorBoundary>
);
